import {Modal} from "react-bootstrap";
import DisplayAmount from './DisplayAmount'
function LoginModal(props) {
   
    return (
        <Modal {...props} centered className={'login-modal'}>
            {
                /*
<div className={'closeloginbtn'} onClick={props.onHide}>X</div>
                */
            }
                

            <Modal.Body className={'contentmodal py-4'}>
            <div className="text-center mb-1 boxmodal">
            ຍອດເງີນ  ທີ່ສາມາດຂໍຄິວອາ
            </div>
                <div className="text-center mb-1 boxmodal mt-3">
               
                <DisplayAmount 
  qrcodeitems={props.qrcodeitems}
  numberWithCommas={props.numberWithCommas}
/>
                </div>
                
              
                <div className={'btn btn-danger btn-lg w-100'}
                                    onClick={props.onHide}    >
                                        ປິດ
                                    </div>
                
            </Modal.Body>
        </Modal>
    );
}

export default LoginModal;
